import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useRef, useState } from "react";
import UploadIcon from '@mui/icons-material/Upload';
import { MyListApi } from "../utils/restApi";
import { MYLIST_APP } from "../constants/constants";

export const ProfileImageUploadDialog = ({ value, label, onChange = () => {}}) => {

    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(value);
    const [preview, setPreview] = useState(null);
    const fileUploadRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setPreview(URL.createObjectURL(event.target.files[0]));
    };

    const handleInputClick = () => {
        fileUploadRef.current.click();
    }

    const handleClose = (_, reason) => {
        if (reason != 'backdropClick') {
            setOpen(false);
        }
    }

    const handleUpload = () => {
        MyListApi.uploadProfileImage(selectedFile)
            .then(response => {
                setOpen(false);
                setUploadedFile(response.filename);
                onChange?.(response);
            })
            .catch(error => {
            });
    }

    return (
        <Box>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{`Upload image for ${label}`}</DialogTitle>
                <DialogContent>
                    <Box sx={{ border: "dashed 2px lightblue", width: "100px", height: "100px", alignItems: 'center', display: 'flex', justifyContent: 'center', padding: '8px' }}>
                        {preview ? <img style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} src={preview} /> : null}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handleInputClick}>Select File(s)</Button>
                    <Button onClick={handleUpload}>Upload</Button>
                </DialogActions>
            </Dialog>
            <Typography fontWeight="bold">{label}</Typography>
            <Box sx={{ border: "dashed 2px lightblue", width: "100px", height: "100px", alignItems: 'center', display: 'flex', justifyContent: 'center', padding: '8px' }}>
                {uploadedFile ?
                    <img style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} src={`${MYLIST_APP.S3_BUCKET_HOST}/${uploadedFile}`} />
                : <Typography>No Image</Typography>}
            </Box>
            <Button variant="contained" endIcon={<UploadIcon />} onClick={() => setOpen(true)}>
                Upload
            </Button>
            <input type="file" accept=".jpg,.jpeg,.png" onChange={handleFileChange} ref={fileUploadRef} hidden />
        </Box>
    );
}